import { Header } from "@obs/base";
import { useLocale } from "@obs/components";
import { createFileRoute, Navigate, Outlet } from "@tanstack/react-router";
import { IntlProvider } from "react-intl";

import { useAccount } from "../Components/Account/AccountProvider";
import { getMessages } from "../intl/getMessages";
import type { SupportedLocale } from "../types/types";

export const Route = createFileRoute("/_accountLayout")({
	component: RouteComponent,
});

function RouteComponent() {
	const { isAuthenticated } = useAccount();
	const { locale } = useLocale();

	if (isAuthenticated) {
		return <IntlProvider messages={getMessages(locale as SupportedLocale)} locale={locale}><Navigate to="/stations" replace /></IntlProvider>;
	}

	return (
		<IntlProvider messages={getMessages(locale as SupportedLocale)} locale={locale}>
			<Header.Web />
			<Outlet />
		</IntlProvider>
	);
}
